/**
 * Error representing a not found resource
 */
export class NotFoundError extends Error {
    constructor(message) {
        super();
        Error.captureStackTrace(this, this.constructor);
        this.message = message;
    }
}
//# sourceMappingURL=not-found-error.js.map